/**
 * Lệnh Bot — Share TKQC navigation config.
 *
 * Trang Share TKQC nằm hoàn toàn dưới prefix `/admin/lenh-bot/share-tkqc`.
 */

export const SHARE_TKQC_ROUTE_NAME = 'LenhBotShareTkqc'
export const SHARE_TKQC_ITEM_ID    = 'lenh-bot-share-tkqc'
export const SHARE_TKQC_LABEL      = 'Share TKQC'
export const SHARE_TKQC_TITLE      = 'Lệnh Bot · Share TKQC'
